import { writable } from "svelte/store";
import type { DeviceInformationState, DeviceInformationStore } from "./types";
import { logger } from "$lib/logger";
import { route } from "$lib/ROUTES";

type CreateDeviceInformationStoreParams = {
	devicePayload: DeviceInformationState["devicePayload"];
};

export const createDeviceInformationStore = (
	props: CreateDeviceInformationStoreParams,
): DeviceInformationStore => {
	const { subscribe } = writable<DeviceInformationState>({
		devicePayload: props.devicePayload,
	});

	return {
		subscribe,
	};
};
